import {
  AccountActionTypes,
  IFetchWorkspacesPayload,
  IFetchWorkspacesSuccessResponseBody,
  ISetCurrentAccountPayload,
  IRenameAccountPayload,
  IRenameAccountSuccessPayload,
  IChangeAvatarPayload,
  IChangeAvatarSuccessPayload,
  IChangeTranslationProviderCredentialsPayload,
  IChangeTranslationProviderCredentialsSuccessPayload,
  IMoveProjectsToOtherWorkspacePayload,
} from './types'

export const resetCurrentAccount = () => ({
  type: AccountActionTypes.RESET_CURRENT_ACCOUNT,
})

export const fetchWorkspaces = (payload: IFetchWorkspacesPayload) => ({
  type: AccountActionTypes.FETCH_WORKSPACES,
  payload,
})

export const fetchWorkspacesSuccess = (payload: IFetchWorkspacesSuccessResponseBody) => ({
  type: AccountActionTypes.FETCH_WORKSPACES_SUCCESS,
  payload,
})

export const fetchWorkspacesFailure = () => ({
  type: AccountActionTypes.FETCH_WORKSPACES_FAILURE,
})

export const setCurrentAccount = (payload: ISetCurrentAccountPayload) => ({
  type: AccountActionTypes.SET_CURRENT_ACCOUNT,
  payload,
})

export const renameAccount = (payload: IRenameAccountPayload) => ({
  type: AccountActionTypes.RENAME_ACCOUNT,
  payload,
})

export const renameAccountSuccess = (payload: IRenameAccountSuccessPayload) => ({
  type: AccountActionTypes.RENAME_ACCOUNT_SUCCESS,
  payload,
})

export const renameAccountFailure = () => ({
  type: AccountActionTypes.RENAME_ACCOUNT_FAILURE,
})

export const setUploadingAvatar = () => ({
  type: AccountActionTypes.SET_UPLOADING_AVATAR,
})

export const changeAvatar = (payload: IChangeAvatarPayload) => ({
  type: AccountActionTypes.CHANGE_AVATAR,
  payload,
})

export const changeAvatarSuccess = (payload: IChangeAvatarSuccessPayload) => ({
  type: AccountActionTypes.CHANGE_AVATAR_SUCCESS,
  payload,
})

export const changeAvatarFailure = () => ({
  type: AccountActionTypes.CHANGE_AVATAR_FAILURE,
})

export const changeTranslationProviderCredentials = (payload: IChangeTranslationProviderCredentialsPayload) => ({
  type: AccountActionTypes.CHANGE_TRANSLATION_PROVIDER_CREDENTIALS,
  payload,
})

export const changeTranslationProviderCredentialsSuccess = (payload: IChangeTranslationProviderCredentialsSuccessPayload) => ({
  type: AccountActionTypes.CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_SUCCESS,
  payload,
})

export const changeTranslationProviderCredentialsFailure = () => ({
  type: AccountActionTypes.CHANGE_TRANSLATION_PROVIDER_CREDENTIALS_FAILURE,
})

export const moveProjectsToOtherWorkspace = (payload: IMoveProjectsToOtherWorkspacePayload) => ({
  type: AccountActionTypes.MOVE_PROJECTS_TO_OTHER_WORKSPACE,
  payload,
})

export const moveProjectsToOtherWorkspaceSuccess = () => ({
  type: AccountActionTypes.MOVE_PROJECTS_TO_OTHER_WORKSPACE_SUCCESS,
})

export const moveProjectsToOtherWorkspaceFailure = () => ({
  type: AccountActionTypes.MOVE_PROJECTS_TO_OTHER_WORKSPACE_FAILURE,
})
